import cx from "classnames"
import PropTypes from "prop-types"
import React from "react"
import * as css from "./CardGroup.module.css"
import Overflow from "components/Layout/Overflow"

function CardGroup({
  className,
  spacing,
  children,
  overflow,
  itemsPerRow,
  stackable,
  ...rest
}) {
  const classNames = cx(css.root, className, {
    [css.spacing1x]: spacing === "1x",
    [css.spacing2x]: spacing === "2x",
    [css[`cols${itemsPerRow}`]]: !!itemsPerRow,
  })

  if (overflow) {
    return (
      <Overflow>
        <div className={classNames} {...rest}>
          {children}
        </div>
      </Overflow>
    )
  }

  return (
    <div className={classNames} {...rest}>
      {children}
    </div>
  )
}

CardGroup.propTypes = {
  className: PropTypes.string,
  spacing: PropTypes.oneOf(["1x", "2x"]),
  overflow: PropTypes.bool,
  itemsPerRow: PropTypes.number,
  stackable: PropTypes.bool,
}

export default CardGroup
